module.exports = __webpack_public_path__ + "img/logo.e5909b31.png";